import React from 'react'

const ErrorElement = () => {
    return (
        <div className='text-4xl flex justify-center mt-52 bg-red-400 w-3/4 mx-auto p-4 text-white font-semibold rounded-lg'>404 Not Found</div>
    )
}

export default ErrorElement